import { ContactButton, ContactButtonMethod } from "components/Button";
import ClientTranslation from "components/ClientTranslation";
import Feedback from "components/Feedback";
import Flex from "components/Flex";
import Image from "components/Image";
import PageLayout from "components/PageLayout";
import Text from "components/Text";

import { useClientTranslation } from "hooks/useClientTranslation";
import { usePageTracking } from "hooks/usePageTracking";

import { useConfig } from "../../hooks/useConfig";

export const FlowCompleted = () => {
  const { displayName: client, flowCompleted, contactButton, showFeedbackCompleted } = useConfig();

  usePageTracking({ name: "Done - view" });

  const showFeedback = showFeedbackCompleted ?? true; 

  const { t } = useClientTranslation();

  return (
    <PageLayout title={t("done.header")} dataTestId="flowCompleted">
      <Feedback visible={showFeedback}>
        <Text sizeVariant="md" mx={24} mt={8}>
          {t("done.instruction")}
        </Text>
        {contactButton ? (
          <Flex mx={24}>
            <ContactButton contactMethod={contactButton.type as ContactButtonMethod} url={contactButton.url}>
              <ClientTranslation i18nKey="estimate.contact_button">{{ client }}</ClientTranslation>
            </ContactButton>
          </Flex>
        ) : (
          <Flex mb={8}>
            <Image
              src="/assets/svg/flow-completed.svg"
              alt="Flow Completed"
              overrides={flowCompleted?.illustrations?.main}
            />
          </Flex>
        )}
      </Feedback>
    </PageLayout>
  );
};
